import classNames from 'classnames';
import { forwardRef } from 'react';
const flexContainerCss = "f1g9utzr";
export const FlexContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(flexContainerCss, props.className)} />;
});

require("./styles.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");